import { Component, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Component({
  selector: 'canvas-form-error',
  templateUrl: './form-error.component.html',
  standalone: false,
})
export class FormErrorComponent {
  @Input() errors?: ValidationErrors | null;
  @Input() errorMessages: { [key: string]: string } = {};

  get firstErrorKey(): string | null {
    if (!this.errors) return null;

    const activeErrors = Object.keys(this.errors).filter(
      (key) => this.errors?.[key]
    );
    return activeErrors.length > 0 ? activeErrors[0] : null;
  }
}
